import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IProviderCaseload } from '../Models/IProviderCaseload';
import { INonProviderCaseload } from '../Models/INonProviderCaseload';

@Injectable()
export class CaseloadService extends BaseService {
  _baseUrl: string = "";
  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getProviderCaseloadList(): Observable<IProviderCaseload[]> {
    return this._http.get<IProviderCaseload[]>(this._baseUrl + "api/Caseload/GetProviderCaseloadList")
      .map((response: IProviderCaseload[]) => response as IProviderCaseload[])
      .catch(this.errorHandler);
  }

  getSELPASysAdminCaseloadList(): Observable<IProviderCaseload[]> {
    return this._http.get<IProviderCaseload[]>(this._baseUrl + "api/Caseload/GetSELPASysAdminCaseloadList")
      .map((response: IProviderCaseload[]) => response as IProviderCaseload[])
      .catch(this.errorHandler);
  }

  getAdministratorClerkCaseloadList(): Observable<INonProviderCaseload[]> {
    return this._http.get<INonProviderCaseload[]>(this._baseUrl + "api/Caseload/GetAdministratorClerkCaseloadList")
      .map((response: INonProviderCaseload[]) => response as INonProviderCaseload[])
      .catch(this.errorHandler);
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

}
